import { render, staticRenderFns } from "./unusual.vue?vue&type=template&id=32884ca2&scoped=true"
import script from "./unusual.vue?vue&type=script&lang=js"
export * from "./unusual.vue?vue&type=script&lang=js"
import style0 from "./unusual.vue?vue&type=style&index=0&id=32884ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32884ca2",
  null
  
)

export default component.exports